/* tslint:disable */
/* eslint-disable */
/**
 * e-SNRWB
 * Opis api e-SNRWB
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateUpdateDictionaryDto
 */
export interface CreateUpdateDictionaryDto {
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateDictionaryDto
     */
    shortname?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateDictionaryDto
     */
    value?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateDictionaryDto
     */
    parentId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateDictionaryDto
     */
    dictionaryTypeId: string;
}

export function CreateUpdateDictionaryDtoFromJSON(json: any): CreateUpdateDictionaryDto {
    return CreateUpdateDictionaryDtoFromJSONTyped(json, false);
}

export function CreateUpdateDictionaryDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateUpdateDictionaryDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'shortname': !exists(json, 'shortname') ? undefined : json['shortname'],
        'value': !exists(json, 'value') ? undefined : json['value'],
        'parentId': !exists(json, 'parentId') ? undefined : json['parentId'],
        'dictionaryTypeId': json['dictionaryTypeId'],
    };
}

export function CreateUpdateDictionaryDtoToJSON(value?: CreateUpdateDictionaryDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'shortname': value.shortname,
        'value': value.value,
        'parentId': value.parentId,
        'dictionaryTypeId': value.dictionaryTypeId,
    };
}


